import styled from 'styled-components';
import { TableLayout } from '../components/table/styles';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  padding: 5px;
  
  background: #EEEEEE;

  display: flex;
  justify-content: center;
  align-items: center;
`;